import { ORIENTATION } from 'src/services/constants';

export default () => {
  let readyResolve;
  const onReady = new Promise((resolve) => {
    readyResolve = resolve;
  });

  let routerReadyResolve;
  const onRouterReady = new Promise((resolve) => {
    routerReadyResolve = resolve;
  });

  let workersReadyResolve;
  const onWorkersReady = new Promise((resolve) => {
    workersReadyResolve = resolve;
  });

  return {
    accountSettingsDialogOpen: false,
    broker: null,
    brokerPromise: null,
    deviceInfo: null,
    isFilterRoute: false,
    isLiveMapRoute: false,
    liveUpdateInfo: null,
    mainNavOpen: false,
    notchSizes: {
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
    },
    onReady,
    onRouterReady,
    onWorkersReady,
    orientation: ORIENTATION.TOP,
    readyResolve,
    routerReadyResolve,
    workersReadyResolve,
  };
};
